import React from 'react';
import './form.css';
import logo from './logo512.png';
import { connect } from "react-redux";
import * as actions from '../store/actions/documentActions';
import ListCard from '../components/List-Card';

class CustomForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          buttonValue : true
        }
        this.fileInput = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    
    handleChange = () => {
      if (this.fileInput.current !== null){
        if (this.fileInput.current.files.length > 0) {
          var regex = String(this.fileInput.current.files[0].name).trim()
          
          if (/.pdf$/.test(regex)){
            this.setState({
              buttonValue: false
            });
          }
          else if (/.txt$/.test(regex)){
            this.setState({
              buttonValue: false
            });
          }
          else if (/.docx$/.test(regex)){
            this.setState({
              buttonValue: false
            });
          }
          else{
            this.setState({
              buttonValue: true
            }); 
          }
           
        }
      }
      }; 
      handleSubmit(event) {
        event.preventDefault();
        let form_data = new FormData();
        form_data.append('document', this.fileInput.current.files[0], this.fileInput.current.files[0].name);
        form_data.append('description', event.target.elements.content.value);
        this.props.create_document(this.props.token, form_data); 

        //document.getElementById("form").reset();
      }; 
    render() {
        
      return (
          <>
        <ListCard content={<h2>Upload New Document.</h2>}/>
        {  this.props.loading ?
        <div className='footer-logo'>
        <h1 >Please do not close this page while it loads.</h1>
        <img  className='App-logo' src={logo} alt='logo'/> </div>
         :
        <form id='form' onSubmit={this.handleSubmit}>
            <label className='label'>
            <p>Description: </p> 
            <textarea id='textarea' name="content"  placeholder="Input a description ..."/>        </label>
            <label className='labelT'>
            Select Document: <input type="file" name='document' onChange={this.handleChange} ref={this.fileInput} /> </label>
            <p>Note: Upload button won't work until you input <br/> a PDF(.pdf),word (.docx) or plain text (.txt) file.</p>
          <input id='uploadButton'type="submit" value='Upload' disabled={this.state.buttonValue}/>
        </form> }
        </>
      );
    }
  }
  const mapStateToProps = state => {
    return {
      loading: state.loading,
      token: state.token
    };
  };
  const mapDispatchToProps = dispatch => {
    return {
      create_document: (token, form_data) => dispatch(actions.create_document(token, form_data))
    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(CustomForm); 
  